import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createUserRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/user/staff",
    component: lazyRouteComponent(() => import("pages/user/staff")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/user/organization",
    component: lazyRouteComponent(() => import("pages/user/organization")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/user/auth_logs",
    component: lazyRouteComponent(() => import("pages/user/auth_logs")),
  }),
  // Read-only audit trail of what staff did on the admin API — auth_logs answers who
  // signed in, this answers what they did next.
  createRoute({
    getParentRoute: () => parent,
    path: "/user/activity_logs",
    component: lazyRouteComponent(() => import("pages/user/activity_logs")),
  }),
];
